import { ICanvasPage } from '@src/js/auto-test/canvas-e2e/interface/canvas-page.interface';
import type { Application } from '@tencent/alloy-renderer';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import {
    ICanvasRendererService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/base/canvas-renderer-service.interface';

declare global {
    interface Window {
        canvasPage: ICanvasPage;
    }
}

export default class CanvasE2EManager {
    private static instance: CanvasE2EManager;

    public static getInstance(): CanvasE2EManager {
        if (!CanvasE2EManager.instance) {
            CanvasE2EManager.instance = new CanvasE2EManager();
        }
        return CanvasE2EManager.instance;
    }

    private readonly appsInThumbListMap: Map<any, Application>;  // 存储左侧列表application
    private hasCanvasPage: boolean;  // 标记是否已经挂载canvasPage
    private selection: ISelectionService | undefined;
    private rendererService: ICanvasRendererService | undefined;

    private constructor() {
        this.appsInThumbListMap = new Map();
        this.hasCanvasPage = false;
    }

    public init(): void {
        this.hasCanvasPage = true;
        import(/* webpackChunkName: "auto-test" */ './canvas-page').then((module) => {
            if (module.default) {
                const CanvasPage = module.default;
                window.canvasPage = new CanvasPage() as ICanvasPage;
                if (this.selection && this.rendererService) {
                    (window.canvasPage as ICanvasPage).setServiceDelegate({
                        selectionService: this.selection,
                        rendererService: this.rendererService,
                    });
                }
            }
        })
            .catch((error) => {
                window.log.error(`[load CanvasPage-error]${error}`);
            });
    }

    public setServiceDelegate(services: {
        selection: ISelectionService,
        rendererService: ICanvasRendererService,
    }): void {
        if (this.selection) return;
        this.selection = services.selection;
        this.rendererService = services.rendererService;
        if (window.canvasPage) {
            (window.canvasPage as ICanvasPage).setServiceDelegate({
                selectionService: services.selection,
                rendererService: services.rendererService,
            });
        }
    }

    public addThumbApplication(slideMode, app: Application): void {
        if (!this.hasCanvasPage) return;
        this.appsInThumbListMap.set(slideMode, app);
    }

    public removeThumbApplication(slideMode): void {
        if (!this.hasCanvasPage) return;
        this.appsInThumbListMap.delete(slideMode);
    }

    public getThumbApplications(): Map<any, Application> | null {
        if (!this.hasCanvasPage) return null;
        return this.appsInThumbListMap;
    }
}
